export enum IngredientUnit {
  Percent,
  GramsPerLiter,
}
